var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04293 0H17.9536C18.5284 0 18.9966 0.460417 18.9966 1.02578V11.9708C18.9966 12.5362 18.5284 12.9966 17.9536 12.9966H1.04293C0.468116 13 0 12.5396 0 11.9742V1.02578C0 0.460417 0.468116 0 1.04293 0Z",
    fill: "#B22234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00688406 0.924194H18.9966C19 0.958049 19.0034 0.991903 19.0034 1.02914V2.02445H0V1.02576C0 0.991903 0.00344203 0.958049 0.00688406 0.924194ZM19 2.93513V4.03201H0V2.93513H19ZM19 4.94607V6.04294H0V4.94607H19ZM19 6.95701V8.05388H0V6.95701H19ZM19 8.96794V10.0648H0V8.96794H19ZM19 10.9789V11.9708C19 12.0047 18.9966 12.0419 18.9931 12.0758H0.00688406C0.00344203 12.0453 0 12.008 0 11.9742V10.9823H19V10.9789Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15942 0V7.00104H0V1.02578C0 0.460417 0.468116 0 1.04293 0H7.15942Z",
    fill: "#3C3B6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.423129 0.968262L0.660629 1.69613L0.0341797 1.24587H0.812078L0.182187 1.69613L0.423129 0.968262Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.423129 2.37659L0.660629 3.10445L0.0341797 2.65419H0.812078L0.182187 3.10445L0.423129 2.37659Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.423129 3.78491L0.660629 4.51278L0.0341797 4.06252H0.812078L0.182187 4.51278L0.423129 3.78491Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.423129 5.19324L0.660629 5.9211L0.0341797 5.47084H0.812078L0.182187 5.9211L0.423129 5.19324Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26297 0.264038L1.50391 0.991903L0.874023 0.541642H1.65536L1.02203 0.991903L1.26297 0.264038Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26297 1.67236L1.50391 2.40023L0.874023 1.94997H1.65536L1.02203 2.40023L1.26297 1.67236Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26297 3.08069L1.50391 3.80855L0.874023 3.35829H1.65536L1.02203 3.80855L1.26297 3.08069Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26297 4.48901L1.50391 5.21688L0.874023 4.76662H1.65536L1.02203 5.21688L1.26297 4.48901Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26297 5.89734L1.50391 6.6252L0.874023 6.17494H1.65536L1.02203 6.6252L1.26297 5.89734Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10672 0.968262L2.34766 1.69613L1.71777 1.24587H2.49567L1.86578 1.69613L2.10672 0.968262Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10672 2.37659L2.34766 3.10445L1.71777 2.65419H2.49567L1.86578 3.10445L2.10672 2.37659Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10672 3.78491L2.34766 4.51278L1.71777 4.06252H2.49567L1.86578 4.51278L2.10672 3.78491Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10672 5.19324L2.34766 5.9211L1.71777 5.47084H2.49567L1.86578 5.9211L2.10672 5.19324Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9495 0.264038L3.187 0.991903L2.56055 0.541642H3.33845L2.70855 0.991903L2.9495 0.264038Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9495 1.67236L3.187 2.40023L2.56055 1.94997H3.33845L2.70855 2.40023L2.9495 1.67236Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9495 3.08069L3.187 3.80855L2.56055 3.35829H3.33845L2.70855 3.80855L2.9495 3.08069Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9495 4.48901L3.187 5.21688L2.56055 4.76662H3.33845L2.70855 5.21688L2.9495 4.48901Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9495 5.89734L3.187 6.6252L2.56055 6.17494H3.33845L2.70855 6.6252L2.9495 5.89734Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78934 0.968262L4.03028 1.69613L3.40039 1.24587H4.17829L3.5484 1.69613L3.78934 0.968262Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78934 2.37659L4.03028 3.10445L3.40039 2.65419H4.17829L3.5484 3.10445L3.78934 2.37659Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78934 3.78491L4.03028 4.51278L3.40039 4.06252H4.17829L3.5484 4.51278L3.78934 3.78491Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78934 5.19324L4.03028 5.9211L3.40039 5.47084H4.17829L3.5484 5.9211L3.78934 5.19324Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63309 0.264038L4.87403 0.991903L4.24414 0.541642H5.02204L4.39215 0.991903L4.63309 0.264038Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63309 1.67236L4.87403 2.40023L4.24414 1.94997H5.02204L4.39215 2.40023L4.63309 1.67236Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63309 3.08069L4.87403 3.80855L4.24414 3.35829H5.02204L4.39215 3.80855L4.63309 3.08069Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63309 4.48901L4.87403 5.21688L4.24414 4.76662H5.02204L4.39215 5.21688L4.63309 4.48901Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63309 5.89734L4.87403 6.6252L4.24414 6.17494H5.02204L4.39215 6.6252L4.63309 5.89734Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47293 0.968262L5.71388 1.69613L5.08398 1.24587H5.86188L5.23543 1.69613L5.47293 0.968262Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47293 2.37659L5.71388 3.10445L5.08398 2.65419H5.86188L5.23543 3.10445L5.47293 2.37659Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47293 3.78491L5.71388 4.51278L5.08398 4.06252H5.86188L5.23543 4.51278L5.47293 3.78491Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47293 5.19324L5.71388 5.9211L5.08398 5.47084H5.86188L5.23543 5.9211L5.47293 5.19324Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31571 0.264038L6.55665 0.991903L5.92676 0.541642H6.70466L6.07477 0.991903L6.31571 0.264038Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31571 1.67236L6.55665 2.40023L5.92676 1.94997H6.70466L6.07477 2.40023L6.31571 1.67236Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31571 3.08069L6.55665 3.80855L5.92676 3.35829H6.70466L6.07477 3.80855L6.31571 3.08069Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31571 4.48901L6.55665 5.21688L5.92676 4.76662H6.70466L6.07477 5.21688L6.31571 4.48901Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31571 5.89734L6.55665 6.6252L5.92676 6.17494H6.70466L6.07477 6.6252L6.31571 5.89734Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.42df833eaa8178408ba1bae83315f815.svg";
export { ForwardRef as ReactComponent };